

















































































import { Component } from 'vue-property-decorator'
import ViewBase from '@/util/ViewBase'
import { getCateList, getAccountList, accountDel } from '@/api/admin'
import AccountForm from './accountForm.vue'
import conFirm from './confirm.vue'
import { post, get } from '@/fn/ajax'
import { Tooltip, Modal, message } from 'ant-design-vue'
@Component({
  components: {
    AccountForm,
    conFirm
  }
})
export default class ResourceList extends ViewBase {
  lang = {}

  doc: any = null

  columns: any = null

  pagination: any = null

  loading: boolean = false

  list: any = []

  deleteConfirm: boolean = false

  deleteId: string = ''

  submiting: boolean = false
  // 已用云盘空间
  used: string = ''
  //  剩余云盘空间
  total: string = ''

  get i18n() {
    const value = this.$t('login')
    return value as any
  }

  handleTableChange(pagination: any) {
    // console.log(pagination)
    const pager: any = { ...this.pagination }
    pager.current = pagination.current
    this.pagination = pager
    this.fetch({
      page: pagination.current
    })
  }

  cancelMod() {
    this.deleteConfirm = false
  }

  async postDel(data: any) {
    this.submiting = true
    const res = await post('/api/UserRes/del', data)
    return res
  }

  async deleteResource() {
    const pdata: any = {
      rid: this.deleteId
    }
    try {
      const res = await this.postDel(pdata)
      this.submiting = false
      this.$message.success(res.msg)
      this.deleteConfirm = false
      this.fetch({
        page: this.pagination.current || 1,
        phase: 0,
        subject: 0
      })
    } catch (ex) {
      this.handleError(ex)
    }
  }

  toEdit(id: any) {
    this.$router.push({
      name: 'resourceListUpload',
      params: { id: id + '' }
    })
  }

  deleteClick(id: any) {
    this.deleteConfirm = true
    this.deleteId = id
  }

  async fetch(params: any = {}) {
    this.loading = true
    try {
      const res = await post('/api/UserRes/alist', params)
      if (res && res.data) {
        const data = res.data
        this.loading = false
        const pagination: any = { ...this.pagination }
        // Read total count from server
        // pagination.total = data.totalCount;
        pagination.total = data.total
        this.loading = false
        this.list = data.list
        this.pagination = pagination
        this.getCloudSpace()
      }
    } catch (ex) {
      this.handleError(ex)
    }
  }

  getCloudSpace() {
    post('/api/UserRes/schoolCloudDisk').then(res => {
      if (res) {
        const data: any = res.data
        this.used = data.used
        this.total = data.total
      }
    })
  }

  toAdd() {
    this.$router.push({
      name: 'resourceListUpload',
      params: {}
    })
  }
  setColums() {
    const lang: any = this.lang
    this.columns = [
      {
        title: lang.resourceId,
        dataIndex: 'rid',
        align: 'center'
      },
      {
        title: lang.listCover,
        dataIndex: 'cover',
        className: 'texcenter width80',
        scopedSlots: { customRender: 'image' },
        align: 'center'
      },
      {
        title: lang.listName,
        dataIndex: 'title',
        align: 'center'
      },
      {
        title: lang.resourceType,
        dataIndex: 'res_type_name',
        align: 'center'
      },
      {
        title: lang.updater,
        dataIndex: 'user_name',
        align: 'center'
      },
      {
        title: lang.dataSize,
        dataIndex: 'file_size',
        align: 'center'
      },
      {
        title: lang.updateTime,
        dataIndex: 'ctime',
        className: 'resource-time',
        align: 'center'
      },
      {
        title: lang.refreshTime,
        dataIndex: 'utime',
        className: 'resource-time',
        align: 'center'
      },
      {
        title: lang.operation,
        dataIndex: 'operation',
        className: 'texcenter wid260 operation',
        scopedSlots: { customRender: 'operation' }
      }
    ]
  }
  created() {
    this.doc = window.document
    this.lang = this.i18n.resource
    this.setColums()
    this.fetch()
  }
}
